import type AttachmentStore from "./schema/AttachmentStore";
import { createStore } from "owa-satcheljs";

const attachmentStore: AttachmentStore = {
    attachments: new Map([]),
    attachmentIdsByParentItemId: new Map([]),
};

export const getStore: () => AttachmentStore = createStore<AttachmentStore>("attachment", attachmentStore);
export default getStore;
